import { createThunkActions } from '../../../utilities';

export const getBillingInfo = createThunkActions('@@billing/GET_INFO');
export const setBillingInfo = createThunkActions('@@billing/SET_INFO');
